import errorManager from '@/rollbar.js';

const setListener = (exemptionSelect, posizioneTicketSelect, codiceEsenzioneText) => {
  $(exemptionSelect).on('select2:select', function (e) {
    const posizioneTicket = $(this).find(':selected').data('posizioneTicket');
    const codAsl = $(this).find(':selected').data('codAsl');
    $(codiceEsenzioneText).val(codAsl);
    $(posizioneTicketSelect).val(posizioneTicket).trigger('change');
  });
};

const init = (exemptionSelect, posizioneTicketSelect, codiceEsenzioneText) => {
  try {
    setListener(exemptionSelect, posizioneTicketSelect, codiceEsenzioneText);
  } catch (e) {
    errorManager(e);
  }
};

window.CalcPosizioneTicket = {
  init: init,
};
